import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';

@Component({
    selector: 'title-translate',
    templateUrl: './title-translate.component.html',
    styleUrls: ['title-translate.component.scss'],
    providers: [DeeplTranslationService],
    standalone: false
})

export class TitleTranslateComponent implements OnInit {
  @Input() asset;
  @Input() isLoading = false;
  @Input() selectedLanguages;
  @Input() languages;
  @Input() showInFrontCheckbox = false;
  @Input() packageLang;
  @Input() packageId;
  @Input() showSave = true;
  @Output() save = new EventEmitter();
  @Output() changed = new EventEmitter();

  changeLang = false;
  isTranslating = false;
  constructor(private dialog: MatDialog, private translation: DeeplTranslationService) {
  }

  ngOnInit() {
    if (!this.asset.title && this.asset.originalFileName) {
      this.asset.title = this.asset.originalFileName;
    }
  }

  async addLanguage() {
    let selectedLang = this.selectedLanguages.map(el => el.language);
    if (!selectedLang || !selectedLang.length) {
      selectedLang = [this.packageLang];
    }
    let dialogRef: MatDialogRef<LanguageSelectorComponent>;
    dialogRef = this.dialog.open(LanguageSelectorComponent, <any>{ width: '656px', data: { selected: selectedLang, available: this.languages, type: 'add' } });
    const result = await dialogRef.afterClosed().toPromise();
    if (!!result) {
      this.selectedLanguages.push({ language: result.lang, title: '' });
      this.changeLang = true;
    }
  }

  async translateTitleFromMainLanguage(lang: string, index) {
    this.isTranslating = true;
    this.selectedLanguages[index].title = await this.translation.translate(this.asset.title, lang, this.packageId);
    this.isTranslating = false;
    this.emitChange();
  }

  removeTranslation(lang) {
    if (this.selectedLanguages.indexOf(lang) > -1) {
      this.selectedLanguages.splice(this.selectedLanguages.indexOf(lang), 1);
    }
    this.changeLang = true;
    this.emitChange();
  }

  saveTranslation() {
    this.changeLang = false;
    this.save.emit(this.selectedLanguages);
  }

  emitChange() {
    this.changed.emit();
  }
}
